import React from 'react';
import TimezoneSelect from 'react-timezone-select';

// react-timezone-select dressed like the shadcn Select (Settings > Date & time, onboarding).
const styles = {
  control: (base, state) => ({
    ...base,
    backgroundColor: 'transparent',
    borderColor: state.isFocused ? 'hsl(var(--ring))' : 'hsl(var(--input))',
    borderWidth: '1px',
    color: 'hsl(var(--foreground))',
    minHeight: '36px',
    height: '36px',
    boxShadow: state.isFocused ? '0 0 0 1px hsl(var(--ring))' : 'none',
    borderRadius: 'calc(var(--radius) - 2px)',
    fontSize: '0.875rem',
    '&:hover': { borderColor: 'hsl(var(--input))' },
  }),
  valueContainer: (base) => ({ ...base, padding: '0 12px', height: '34px' }),
  indicatorsContainer: (base) => ({ ...base, height: '34px' }),
  menu: (base) => ({
    ...base,
    backgroundColor: 'hsl(var(--popover))',
    border: '1px solid hsl(var(--border))',
    borderRadius: 'var(--radius)',
    overflow: 'hidden',
    zIndex: 50,
  }),
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isFocused ? 'hsl(var(--accent))' : 'transparent',
    color: 'hsl(var(--popover-foreground))',
    cursor: 'pointer',
    fontSize: '0.875rem',
    '&:active': { backgroundColor: 'hsl(var(--accent))' },
  }),
  singleValue: (base) => ({ ...base, color: 'hsl(var(--foreground))' }),
  input: (base) => ({ ...base, color: 'hsl(var(--foreground))' }),
  placeholder: (base) => ({ ...base, color: 'hsl(var(--muted-foreground))' }),
  dropdownIndicator: (base) => ({ ...base, color: 'hsl(var(--muted-foreground))' }),
  indicatorSeparator: () => ({ display: 'none' }),
};

/** A searchable timezone list; `onChange` gets react-timezone-select's option ({ value, label, ... }). */
export function TimezonePicker({ value, onChange, ...props }) {
  return <TimezoneSelect value={value} onChange={onChange} styles={styles} className="timezone-select" {...props} />;
}
